"use client";

import { Toaster } from "sonner";
import { useTheme } from "@/contexts/theme-context";

export function ThemedToaster() {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <Toaster
      theme={isDark ? "dark" : "light"}
      position="top-right"
      toastOptions={{
        style: {
          background: isDark ? "#1a1a1e" : "rgba(255,255,255,0.97)",
          border: isDark ? "1px solid rgba(255,255,255,0.08)" : "1px solid rgba(0,0,0,0.08)",
          color: isDark ? "rgba(255,255,255,0.90)" : "rgba(0,0,0,0.85)",
          boxShadow: isDark
            ? "0 8px 32px rgba(0,0,0,0.4)"
            : "0 8px 32px rgba(0,0,0,0.10)",
        },
      }}
    />
  );
}
